import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { withIntroText, WithIntroTextProps } from '@/components/info/withIntroText';

interface IntroContentProps extends WithIntroTextProps {}

export const IntroContentComponent: React.FC<IntroContentProps> = ({ text }) => {
  return <HelpTextMarkdown id="intro" text={text} />;
};

export const IntroContent = withIntroText(IntroContentComponent);
